export default __webpack_public_path__ + "static/media/avatar3.9f646ac5.png";